module.exports = __webpack_public_path__ + "img/fca13-m-en.0968023b.png";